__turbopack_context__.v({
  "author-row": "review-module-scss-module__TaMjKG__author-row",
  "inner": "review-module-scss-module__TaMjKG__inner",
  "source-row": "review-module-scss-module__TaMjKG__source-row",
  "text": "review-module-scss-module__TaMjKG__text",
  "title": "review-module-scss-module__TaMjKG__title",
});
